import jsPDF from "jspdf";
export default {
    addY(y, by, doc) {
        if (y + by > 275) {
          doc.addPage();
        //   var fontSize = doc.getFontSize();
        //   doc.setFontSize(10);
        //   doc.text(180, 285, "Page " + this.page++);
        //   doc.setFontSize(fontSize);
          return 25;
        } else {
          return y += by;
        }
      },
    generateHtmlforPdf(info, data)
    {
        var doc = new jsPDF();
        doc.setFontSize(9);
        var lineheight = 8;
        var x = 20;
        var y = 20;
        //let //_html=[];
        //_html.push("<html><head>");
        //_html.push("<style>");
        //_html.push("body {");
        //_html.push("margin: 0;");
        //_html.push("font-family: sofia-pro,sans-serif, -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue','Arial';");
        //_html.push("font-size: 1em;");
        //_html.push("font-weight: 400;");
        //_html.push("line-height: 1.5;");
        //_html.push("color: #212529;");
        //_html.push("text-align: left;");
        //_html.push("background-color: #fff;}");
        //_html.push(".container {margin:5px 30px 30px 30px;}");
        //_html.push(".img__container {marging}")
        //_html.push(".box {border:1px solid #dcdcdc;margin:10px;}");
        //_html.push(".box-header {border-bottom:1px solid #dcdcdc;padding:0px 20px;}");
        //_html.push(".box-body { padding:20px;}");
        //_html.push(".header { padding:10px; display:inline-block;}");
        //_html.push(".header h1 { padding:0px; margin:0px;font-size:2em;}");
        //_html.push(".header div, .header img { display:inline-block; margin-left:0px;}");
        //_html.push(".header img { float:left;margin-right:20px; height:30px;}");
        //_html.push(".heading { padding-left:10px; display:block;}");
        //_html.push(".subanswer { padding-left:20px;}");
        //_html.push("</style></head><body><div class=\"container\">"); 
        //_html.push("<div class=\"header\"><div class=\"container\">");
        //_html.push("<img src=\"https://dementiawellbeing.scot.nhs.uk/img/clientLogos/InverclydeHSCP.jpg\" alt=\"Inverclyde HSCP\"/>");
        //_html.push("<img src=\"https://dementiawellbeing.scot.nhs.uk/img/clientLogos/AlzheimerScotland.png\" alt=\"Alzheimer Scotland\"/>");
        //_html.push("<img src=\"https://dementiawellbeing.scot.nhs.uk/img/clientLogos/DHI-logo.png\" alt=\"Digital Health & Care Innovation Centre\"/>");
        //_html.push("<img src=\"https://dementiawellbeing.scot.nhs.uk/img/clientLogos/RDS-logo.png\" alt=\"Right decision service\"/>");
        //_html.push("</div>");
        var fontSize = doc.getFontSize();
        doc.setFontSize(14);
        //doc.setFont(undefined, "bold");
        doc.text("Getting to know me report from Living well with dementia app", x, y);
        //doc.setFont(undefined, "normal");
        doc.setFontSize(fontSize);
        y = this.addY(y, lineheight, doc);
        //_html.push("<div style=\"display:block;\"><h1>Getting to know me report from Living well with dementia app</h1><p><a href=\"https://dementiawellbeing.scot.nhs.uk/\">https://dementiawellbeing.scot.nhs.uk</a></p></div>");
        //_html.push("</div>");
        //_html.push("<div class=\"box\"><div class=\"box-body\">");
        //_html.push("<div><strong>Name: </strong><span>"+info.name+"</span></div>");
        doc.text("Name: " +info.name, x, y);
        y = this.addY(y, lineheight, doc);
        //_html.push("<div><strong>Email address: </strong><span>"+info.email+"</span></div>");
        doc.text("Email address: "+info.email, x, y);
        y = this.addY(y, lineheight, doc);
        //_html.push("<div><strong>Date: </strong><span>"+info.date+"</span></div>");
        doc.text("Date: "+info.date, x, y);
        y = this.addY(y, lineheight, doc);
        //_html.push("</div></div>");

        data.forEach(topic=>{

            var fontSize = doc.getFontSize();
            doc.setFontSize(12);
            //doc.setFont(undefined, "bold");
            doc.text(topic.name, x, y);
            //doc.setFont(undefined, "normal");
            doc.setFontSize(fontSize);
            y = this.addY(y, lineheight, doc);
               
            //_html.push("<div class=\"box\"><div class=\"box-header\"><h3>"+topic.name+"</h3></div>");
            //_html.push("<div class=\"box-body\">");
            //_html.push("<ul>");
                topic.questions.forEach(question=>{
                    //let ////_ans = [];


                    doc.text("Q: "+question.name, x, y);
                    y = this.addY(y, lineheight, doc);
                    //_html.push("<li>");
                    //_html.push("<p><strong><span class=\"outside\">"+question.name+"</span></strong></p>");
                    //doc.text(question.name, x, y);
                    //y = this.addY(y, lineheight, doc);
                        //_html.push(//_answer);
                        //_html.push("</li>");
                    
                    if (question.type === "textarea" && question.content && question.content.length > 0) {
                        //doc.text(question.name, x, y);
                        //y = this.addY(y, lineheight, doc);
                        // //_ans.push("<p>"+question.name+"</p>");
                        doc.text("A: "+question.content, x+5, y);
                        y = this.addY(y, lineheight, doc);
                        //_ans.push("<div class=\"textarea\"><p>"+question.content+"</p></div>");
                    }

                    question.prevalues.forEach((value) => {
                        
                        if (value.selected) {
                            if(value.name.length > 0)
                            {
                                doc.text("Q: "+value.name, x, y);
                                y = this.addY(y, lineheight, doc);
                                //_ans.push("<p><strong>"+value.name+"</strong></p>");
                            }
                            if (value.child && value.child.content && value.child.content.length > 0) {
                                doc.text("Freetext response:", x, y);
                                y = this.addY(y, lineheight, doc);
                                //_ans.push("<div class=\"subanswer\"><p>Freetext response :</p>");
                                doc.text("A: "+value.child.content, x+5, y);
                                y = this.addY(y, lineheight, doc);
                                //_ans.push("<div class=\"textarea\"><p>"+value.child.content+"</p></div></div>");
                            }
                        }
                        if (value.type === "textarea" && value.content && value.content.length > 0) {
                            doc.text("Q: "+value.name, x, y);
                            y = this.addY(y, lineheight, doc);
                            // //_ans.push("<p>"+question.name+"</p>");
                            doc.text("A: "+value.content, x+5, y);
                            y = this.addY(y, lineheight, doc);
                            //_ans.push("<div class=\"textarea\"><p>"+question.content+"</p></div>");
                        }
                    });
                    //let _answer =  "";
                    //if()//_ans.length > 0){
                        //_answer = //_ans.join(" ");
                    //}
                    
                });
            //_html.push("</ul>");
            //_html.push("</div></div>");
        });

        //_html.push("</div></body></html>");
        
        return doc;
    }
}